import { useCurrentUserQuery } from 'src/context/api/auth';
import { useCurrentWorkspace } from 'src/context/reducers/app-settings';
import { INTERNAL_ROLES } from './use-local-feature';

/**
 * Whether Search Performance > Cluster Manager is available for the current user.
 *
 * Shared by the header tab and the route so a customer can't reach by URL a page
 * the navigation hides. Internal roles always see it; `clustermanager_visibility`
 * only gates the customer role. A payload without the field keeps the page
 * visible, as it was before the setting existed.
 */
export const useClusterManagerVisible = (): boolean => {
    const workspace: any = useCurrentWorkspace();
    const user: any = useCurrentUserQuery();
    const role = user?.data?.role;

    if (!role) {
        return false;
    }
    if (INTERNAL_ROLES.includes(role)) {
        return true;
    }
    if (!workspace) {
        return false;
    }
    return !workspace.clustermanager_visibility || workspace.clustermanager_visibility.includes(role);
};
